import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ClientSection.css';

// --- BULK IMPORTS ---
import img1 from '../../../assets/Clients/cit.png';
import img2 from '../../../assets/Clients/velnexus.png';
import img3 from '../../../assets/Clients/velammalvidyalaya.png';
import imgMgr from '../../../assets/Clients/MgrUnivsty.png';
import img4 from '../../../assets/Clients/snm.png';
import img5 from '../../../assets/Clients/FestonSolor.png';
import img6 from '../../../assets/Clients/Feston.png';
import img7 from '../../../assets/Clients/Deye.png';
import img8 from '../../../assets/Clients/semicon.png';
import img9 from '../../../assets/Clients/Fesren.png';
import img10 from '../../../assets/Clients/plugzmart.png';
import img11 from '../../../assets/Clients/caninecrown.png';
import img12 from '../../../assets/Clients/ATSS.png';
import img13 from '../../../assets/Clients/janta.png';
import img14 from '../../../assets/Clients/NVK.png';
import img15 from '../../../assets/Clients/KCee.png';
import img16 from '../../../assets/Clients/JKB.png';
import img17 from '../../../assets/Clients/Aulpha.png';
import img18 from '../../../assets/Clients/Pramatt.png';
import img19 from '../../../assets/Clients/windplus.png';
import img20 from '../../../assets/Clients/vinyas.png';
import img21 from '../../../assets/Clients/horizon.png';
import img22 from '../../../assets/Clients/PrimeAuto.png';
import img23 from '../../../assets/Clients/Traverse.png';
import img24 from '../../../assets/Clients/NilamFresh.png';
import img25 from '../../../assets/Clients/smile.png';
import img26 from '../../../assets/Clients/zique.png';
import img27 from '../../../assets/Clients/upperroom.png';
import img28 from '../../../assets/Clients/flipperclip.png';
import img29 from '../../../assets/Clients/bestforpets.png';
import img30 from '../../../assets/Clients/walt.png';
import img31 from '../../../assets/Clients/sife.png';
import img32 from '../../../assets/Clients/cata.png';
import img33 from '../../../assets/Clients/manasa.png';
import img34 from '../../../assets/Clients/mycons.png';
import img35 from '../../../assets/Clients/greenFuturz.png';
import img36 from '../../../assets/Clients/amalam.png';
import img37 from '../../../assets/Clients/Aiwo.png';
import img38 from '../../../assets/Clients/Dazbog.png';
import img39 from '../../../assets/Clients/DynamicStamping.png';
import img40 from '../../../assets/Clients/Ganga.png';
import img41 from '../../../assets/Clients/SriHousing.png';

// --- COUNTER HOOK ---
const useCounter = (end, duration = 2000, startAnimation) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startAnimation) return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [end, duration, startAnimation]);

  return count;
};

const ClientSection = () => {
  const revealRefs = useRef([]);
  revealRefs.current = [];
  const [statsVisible, setStatsVisible] = useState(false);
  const statsRef = useRef(null);

  // Helper to add elements to ref array
  const addToRefs = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  const clientLogos = [
    img1, img2, img3, imgMgr, img40, img4, img5, img6, img7, img8, img9,
    img10, img11, img12, img13, img14, img15, img16, img17, img18,
    img19, img20, img21, img22, img23, img24, img25, img26, img27,
    img28, img29, img30, img31, img32, img33, img34, img35, img36,
    img37, img38, img39, img41
  ];

  // --- 1. Observer for Logo Cards ---
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    revealRefs.current.forEach((el) => observer.observe(el));

    // --- 2. Observer for Stats Section ---
    const statsObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStatsVisible(true);
        }
      }, { threshold: 0.5 }
    );

    if (statsRef.current) statsObserver.observe(statsRef.current);

    return () => {
      observer.disconnect();
      statsObserver.disconnect();
    }
  }, []);

  // Use Custom Hook for Counting Animation
  const teamCount = useCounter(15, 1000, statsVisible);
  const customerCount = useCounter(1000, 1000, statsVisible);
  const projectCount = useCounter(5, 1000, statsVisible); // Counts to 2, we append 'K' manually

  return (
    <section className="client-section">
      <Container>

        {/* Header Text */}
        <div className="section-header text-center" ref={addToRefs}>
          <h2 className="section-title1">Brands We’ve Worked With</h2>
          <p className="section-subtitle1 mx-auto">
            We partner with brands to create meaningful consistent, and impactful brand experiences.
          </p>
        </div>

        {/* Logo Grid */}
        <Row className="justify-content-center">
          {clientLogos.map((logo, index) => (
            <Col
              key={index}
              xl={2} lg={2} md={3} sm={4} xs={6}
              className="mb-4"
            >
              <div
                className="client-card"
                ref={addToRefs}
                style={{ transitionDelay: `${(index % 6) * 100}ms` }}
              >
                <img src={logo} alt={`Client ${index + 1}`} className="client-logo" />
              </div>
            </Col>
          ))}
        </Row>

        {/* --- STATS SECTION --- */}
        <div className="stats-wrapper" ref={statsRef}>
          <Row className="justify-content-center align-items-center text-center text-md-start">

            {/* Stat 1 */}
            <Col xs={4} md={4} className="stat-col mb-md-0">
              <div className="stat-box">
                <span className="stat-number">{teamCount}+</span>
                <div className="stat-label">
                  Team <br /> members
                </div>
              </div>
            </Col>

            {/* Stat 2 */}
            <Col xs={4} md={4} className="stat-col mb-md-0">
              <div className="stat-box">
                <span className="stat-number">{customerCount}+</span>
                <div className="stat-label">
                  Happy <br /> customers
                </div>
              </div>
            </Col>

            {/* Stat 3 */}
            <Col xs={4} md={4} className="stat-col">
              <div className="stat-box">
                <span className="stat-number">{projectCount}K</span>
                <div className="stat-label">
                  Projects <br /> completed
                </div>
              </div>
            </Col>

          </Row>
        </div>

      </Container>
    </section>
  );
};

export default ClientSection;